import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import Icons from 'common/components/icons'

import './buttonNewMessages.scss'

interface Props {
  hidden: boolean,
  onClick: () => void
}

const ButtonNewMessages = ({ hidden, onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={classnames('btn-scroll-bottom', { hidden })}>
      <button onClick={onClick}>
        <span>{t('chat.newMessages')}</span>
        <Icons prefix="fas" iconName="arrow-down"/>
      </button>
    </div>
  )
}

export default ButtonNewMessages
